import { render, staticRenderFns } from "./ConfPage.vue?vue&type=template&id=1e3fcb38&scoped=true"
import script from "./ConfPage.vue?vue&type=script&lang=js"
export * from "./ConfPage.vue?vue&type=script&lang=js"
import style0 from "./ConfPage.vue?vue&type=style&index=0&id=1e3fcb38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3fcb38",
  null
  
)

export default component.exports